var _require = require('../data/keys'),
    idKeysTranslation = _require.idKeysTranslation; //Simplify Hero7 Labelling style


module.exports = function (str, multi) {
  var newStyle = /\[\[([\w,\s]+)\][,\s\.]*\]/;

  if (str && newStyle.test(str)) {
    var inner = str.match(newStyle)[1].split(',').map(function (s, i) {
      if (i === 0 && multi) s = idKeysTranslation(s);
      return s.trim();
    }).join(',');
    return str.replace(newStyle, " (".concat(inner, ")"));
  }

  return str;
};